// extracted by mini-css-extract-plugin
export default {"slideTitle":"slideTitle__atZwF"};